import { Flex, Box } from '@chakra-ui/react';
import Navbar from '../components/Layout/Navbar';
import Footer from '../components/Layout/Footer';

const MainLayout = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh">
      <Navbar />
      <Flex flex="1">
        <Box flex="1" p={6} py={28} bg="white">
          {children}
        </Box>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default MainLayout;
